import { decodePunycode } from "./punycode.js";

export function toUnicodeUrl(urlString) {
  if (!urlString) return "";

  let decoded = urlString;
  try {
    decoded = decodeURI(urlString);
  } catch (_) {
    // If decoding fails we keep the original value so the URL is still shown.
  }

  let url;
  try {
    url = new URL(decoded);
  } catch (e) {
    return decoded;
  }

  // decodeURI leaves punycode hostnames untouched, so we still need to decode
  // every "xn--" label explicitly to show a human readable domain name.
  const unicodeHost = url.hostname
    .split(".")
    .map((label) => (label.startsWith("xn--") ? decodePunycode(label.slice(4)) || label : label))
    .join(".");

  const port = url.port ? `:${url.port}` : "";
  return `${url.protocol}//${unicodeHost}${port}${url.pathname}${url.search}${url.hash}`;
}
